import {
  fetchAirlinesFailed,
  fetchAirlinesSuccess,
  AIRLINES_FETCH_DATA,
} from "src/redux/actions/airlines";
import { put, call, takeEvery } from "redux-saga/effects";
import { fetchAirlines } from "src/services/airlines";
import { AirlineCodes } from "src/redux/reducers/airlines";

export function* fetchAirlinessSaga() {
  try {
    const payload: { airlineCodes: AirlineCodes } = yield call(fetchAirlines);
    yield put(fetchAirlinesSuccess(payload));
  } catch (ex) {
    yield put(fetchAirlinesFailed(ex));
  }
}

function* airlinesSaga() {
  yield takeEvery(AIRLINES_FETCH_DATA, fetchAirlinessSaga);
}

export default airlinesSaga;
